import { baseApi } from './baseApi';

export const hrmsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployees: builder.query({
      query: (params) => ({
        url: '/hrms/employees',
        params,
      }),
      providesTags: ['Employee'],
    }),
    getEmployee: builder.query({
      query: (id) => `/hrms/employees/${id}`,
      providesTags: (result, error, id) => [{ type: 'Employee', id }],
    }),
    createEmployee: builder.mutation({
      query: (data) => ({
        url: '/hrms/employees',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Employee'],
    }),
    updateEmployee: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/hrms/employees/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        'Employee',
        { type: 'Employee', id },
      ],
    }),
    deleteEmployee: builder.mutation({
      query: (id) => ({
        url: `/hrms/employees/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Employee'],
    }),
    
    // Advances
    getAdvances: builder.query({
      query: (params) => ({
        url: '/hrms/advances',
        params,
      }),
      providesTags: ['EmployeeAdvance'],
    }),
    getAdvance: builder.query({
      query: (id) => `/hrms/advances/${id}`,
      providesTags: (result, error, id) => [{ type: 'EmployeeAdvance', id }],
    }),
    createAdvance: builder.mutation({
      query: (data) => ({
        url: '/hrms/advances',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['EmployeeAdvance'],
    }),
    updateAdvance: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/hrms/advances/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        'EmployeeAdvance',
        { type: 'EmployeeAdvance', id },
      ],
    }),
    deleteAdvance: builder.mutation({
      query: (id) => ({
        url: `/hrms/advances/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmployeeAdvance'],
    }),
    
    // Attendance
    getAttendance: builder.query({
      query: (params) => ({
        url: '/hrms/attendance',
        params,
      }),
      providesTags: ['Attendance'],
    }),
    markDailyBulk: builder.mutation({
      query: (data) => ({
        url: '/hrms/attendance/bulk-daily',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Attendance'],
    }),
    markMonthlyBulk: builder.mutation({
      query: (data) => ({
        url: '/hrms/attendance/bulk-monthly',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Attendance'],
    }),

    // Payroll
    getPayrolls: builder.query({
      query: (params) => ({
        url: '/hrms/payroll',
        params,
      }),
      providesTags: ['Payroll'],
    }),
    generatePayroll: builder.mutation({
      query: (data) => ({
        url: '/hrms/payroll/generate',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Payroll'],
    }),
    markPayrollPaid: builder.mutation({
      query: (id) => ({
        url: `/hrms/payroll/${id}/pay`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Payroll', 'EmployeeAdvance'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetEmployeesQuery,
  useGetEmployeeQuery,
  useCreateEmployeeMutation,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,
  useGetAdvancesQuery,
  useGetAdvanceQuery,
  useCreateAdvanceMutation,
  useUpdateAdvanceMutation,
  useDeleteAdvanceMutation,
  useGetAttendanceQuery,
  useMarkDailyBulkMutation,
  useMarkMonthlyBulkMutation,
  useGetPayrollsQuery,
  useGeneratePayrollMutation,
  useMarkPayrollPaidMutation,
} = hrmsApi;
